import { SEO } from "@/components/SEO";
import { CTAButton } from "@/components/CTAButton";
import { BUSINESS } from "@/lib/site";
import { Phone } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | NorthWork Cyprus" description="The page you are looking for could not be found." path="/404" />
      <section className="container-x flex min-h-[70vh] flex-col items-center justify-center py-24 text-center">
        <span className="font-mono-t text-[11px] uppercase tracking-[0.22em] text-brand">Error 404</span>
        <h1 className="mt-6 font-heading text-5xl font-medium tracking-tight text-charcoal sm:text-6xl">
          Page not found
        </h1>
        <p className="mt-5 max-w-md text-base text-charcoal-muted">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <CTAButton to="/" testid="notfound-home">Back to Home</CTAButton>
          <CTAButton href={`tel:${BUSINESS.phoneTel}`} variant="secondary" icon={Phone} testid="notfound-call">
            {BUSINESS.phoneDisplay}
          </CTAButton>
        </div>
      </section>
    </>
  );
}
